<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
    <template #header>
      <div class="list-page-panel is-header-minimal">
        <div class="list-page-heading">
          <div class="list-page-heading-main">
            <h1 class="list-page-title">岗位管理</h1>
            <p class="list-page-description">统一维护岗位编码、名称、职级与状态</p>
          </div>
        </div>
      </div>
    </template>

    <!-- 操作按钮区域 -->
    <div class="action-toolbar">
      <button
        v-permission="'org:post:add'"
        @click="openAddModal"
        class="btn-primary"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
        新增
      </button>
    </div>

    <!-- 数据表格 + 分页 -->
    <div class="list-page-table-panel">
      <PageFilterBar
        shell-class="filter-bar-shell is-embedded"
        body-class="filter-bar-body is-panel"
        show-refresh
        :refresh-loading="loading"
        @refresh="fetchPosts(page)"
      >
        <input
          v-model="searchCode"
          type="text"
          placeholder="岗位编码"
          class="form-input form-control-sm filter-bar-field"
        >
        <input
          v-model="searchName"
          type="text"
          placeholder="岗位名称"
          class="form-input form-control-sm filter-bar-field"
        >
        <el-select
          v-model="searchStatus"
          placeholder="请选择状态"
          class="form-select form-control-sm filter-bar-field"
        >
          <el-option label="全部状态" value="" />
          <el-option label="正常" :value="true" />
          <el-option label="停用" :value="false" />
        </el-select>

        <template #searchActions>
          <button
            type="button"
            @click="handleSearch"
            class="btn-primary"
          >
            搜索
          </button>
          <button
            type="button"
            @click="resetSearch"
            class="btn-secondary"
          >
            重置
          </button>
        </template>
      </PageFilterBar>

      <div class="data-table-shell">
      <div class="data-table-scroll">
      <table class="data-table">
        <thead class="data-table-head">
          <tr>
            <th class="data-table-th text-left w-12">
              <input
                type="checkbox"
                :checked="selectedIds.length === filteredPosts.length && filteredPosts.length > 0"
                @change="toggleSelectAll"
                class="form-check"
              >
            </th>
            <th class="data-table-th text-left">岗位编码</th>
            <th class="data-table-th text-left">岗位名称</th>
            <th class="data-table-th text-left">别名简称</th>
            <th class="data-table-th text-left">职级</th>
            <th class="data-table-th text-left w-20">排序</th>
            <th class="data-table-th text-left w-24">状态</th>
            <th class="data-table-th text-left w-32">创建时间</th>
            <th class="data-table-th text-left w-32">操作</th>
          </tr>
        </thead>
        <tbody class="data-table-body">
          <tr v-for="post in filteredPosts" :key="post.id" class="data-table-row">
            <td class="data-table-td is-center">
              <input
                type="checkbox"
                :checked="selectedIds.includes(post.id)"
                @change="toggleSelect(post.id)"
                class="form-check"
              >
            </td>
            <td class="data-table-td text-sm text-slate-900">{{ post.code }}</td>
            <td class="data-table-td text-sm text-slate-900 font-medium">{{ post.name }}</td>
            <td class="data-table-td text-sm text-slate-500">{{ post.alias || '-' }}</td>
            <td class="data-table-td text-sm text-slate-500">{{ post.postLevel || '-' }}</td>
            <td class="data-table-td text-sm text-slate-900">{{ post.sort }}</td>
            <td class="data-table-td">
              <span
                class="status-badge"
                :class="post.status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
              >
                <span class="w-1.5 h-1.5 bg-current rounded-full mr-1"></span>
                {{ post.status ? '正常' : '停用' }}
              </span>
            </td>
            <td class="data-table-td text-sm text-slate-500">{{ $formatDateTime(post.createTime) }}</td>
            <td class="data-table-td">
              <div class="flex items-center gap-1">
                <button
                  v-permission="'org:post:edit'"
                  @click="openEditModal(post)"
                  class="table-action-button is-primary"
                  title="修改" aria-label="修改"
                >
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                  </svg>
                </button>
                <button
                  v-permission="'org:post:remove'"
                  @click="handleDelete(post)"
                  class="table-action-button is-danger"
                  title="删除" aria-label="删除"
                >
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

    <!-- 分页 -->
    <AppPagination
      v-if="total > 0"
      class="pagination-bridge"
      :current="page"
      :size="size"
      :total="total"
      :pages="totalPages"
      :page-sizes="[10, 20, 50]"
      @page-change="handlePageChange"
      @size-change="handlePageSizeChange"
    />
    </div>

    <!-- Delete Confirm Modal -->
    <div v-if="showDeleteModal" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="modal-backdrop absolute inset-0" style="background-color: rgba(0, 0, 0, 0.5);" @click="closeDeleteModal"></div>
      <div class="modal-content relative bg-white rounded-xl shadow-xl w-full max-w-sm mx-4" style="animation: slideIn 0.2s ease-out;">
        <div class="p-6 text-center">
          <div class="w-12 h-12 mx-auto mb-4 text-red-500">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
          </div>
          <h3 class="text-lg font-semibold text-slate-900 mb-2">确定要删除吗？</h3>
          <p class="text-sm text-slate-500 mb-6">删除后无法恢复，请确认是否删除。</p>
          <div class="flex items-center justify-center gap-3">
            <button
              @click="closeDeleteModal"
              class="btn-secondary"
            >
              取消
            </button>
            <button
              @click="confirmDelete"
              class="btn-danger-secondary"
            >
              确定删除
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Add/Edit Modal -->
    <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="modal-backdrop absolute inset-0" style="background-color: rgba(0, 0, 0, 0.5);" @click="closeModal"></div>
      <div class="modal-content relative bg-white rounded-xl shadow-xl w-full max-w-lg mx-4" style="animation: slideIn 0.2s ease-out;">
        <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <h3 class="text-lg font-semibold text-slate-900">{{ isEdit ? '修改岗位' : '新增岗位' }}</h3>
          <button @click="closeModal" class="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="p-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">岗位编码 <span class="text-red-500">*</span></label>
            <input
              v-model="form.code"
              type="text"
              class="form-input w-full"
              placeholder="请输入岗位编码"
            >
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">岗位名称 <span class="text-red-500">*</span></label>
            <input
              v-model="form.name"
              type="text"
              class="form-input w-full"
              placeholder="请输入岗位名称"
            >
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">岗位别名简称</label>
            <input
              v-model="form.alias"
              type="text"
              class="form-input w-full"
              placeholder="请输入岗位别名简称"
            >
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">岗位职级</label>
            <input
              v-model="form.postLevel"
              type="text"
              class="form-input w-full"
              placeholder="如：M1、P2、初级、高级"
            >
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">岗位排序 <span class="text-red-500">*</span></label>
            <input
              v-model.number="form.sort"
              type="number"
              class="form-input w-full"
              placeholder="数字越大越靠后"
            >
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">岗位状态</label>
            <el-select
              v-model="form.status"
              class="form-select w-full"
            >
              <el-option label="正常" :value="true" />
              <el-option label="停用" :value="false" />
            </el-select>
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">备注</label>
            <textarea
              v-model="form.remark"
              rows="3"
              class="form-textarea"
              placeholder="请输入备注信息"
            ></textarea>
          </div>
        </div>
        <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl">
          <button
            @click="closeModal"
            class="btn-secondary"
          >
            取消
          </button>
          <button
            @click="savePost"
            class="btn-primary"
          >
            确定
          </button>
        </div>
      </div>
    </div>
  </ListPageShell>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { getPosts, createPost, updatePost, deletePost } from '@/api/post'
import AppPagination from '@/components/AppPagination.vue'
import ListPageShell from '@/components/ListPageShell.vue'
import PageFilterBar from '@/components/PageFilterBar.vue'

// 搜索条件
const searchCode = ref('')
const searchName = ref('')
const searchStatus = ref('')

// 选中项
const selectedIds = ref([])

// 模态框状态
const showModal = ref(false)
const showDeleteModal = ref(false)
const isEdit = ref(false)
const pendingDelete = ref(null)

// 岗位数据
const loading = ref(false)
const posts = ref([])
const total = ref(0)
const page = ref(1)
const size = ref(10)

const totalPages = computed(() => {
  if (!total.value || !size.value) return 1
  return Math.max(1, Math.ceil(total.value / size.value))
})

// 表单数据
const form = reactive({
  id: '',
  code: '',
  name: '',
  alias: '',
  postLevel: '',
  sort: 1,
  status: true,
  remark: ''
})

// 过滤后的岗位列表
const filteredPosts = computed(() => posts.value)

async function fetchPosts(pageOverride) {
  if (pageOverride) {
    page.value = pageOverride
  }
  loading.value = true
  try {
    const params = {
      code: searchCode.value || undefined,
      name: searchName.value || undefined,
      status: searchStatus.value === '' ? undefined : searchStatus.value,
      page: page.value,
      size: size.value
    }
    const data = await getPosts(params)
    const records = Array.isArray(data?.records) ? data.records : []
    posts.value = records
    total.value = Number(data?.total || records.length || 0)
    selectedIds.value = []
  } catch (error) {
    console.error('加载岗位列表失败:', error)
    ElMessage.error(error.message || '加载岗位列表失败')
  } finally {
    loading.value = false
  }
}

function handleSearch() {
  fetchPosts(1)
}

// 重置搜索
function resetSearch() {
  searchCode.value = ''
  searchName.value = ''
  searchStatus.value = ''
  fetchPosts(1)
}

// 全选/取消全选
function toggleSelectAll(e) {
  if (e.target.checked) {
    selectedIds.value = filteredPosts.value.map(p => p.id)
  } else {
    selectedIds.value = []
  }
}

// 选择/取消选择
function toggleSelect(id) {
  const index = selectedIds.value.indexOf(id)
  if (index > -1) {
    selectedIds.value.splice(index, 1)
  } else {
    selectedIds.value.push(id)
  }
}

// 打开新增模态框
function openAddModal() {
  isEdit.value = false
  form.id = ''
  form.code = ''
  form.name = ''
  form.alias = ''
  form.postLevel = ''
  form.sort = 1
  form.status = true
  form.remark = ''
  showModal.value = true
}

// 打开编辑模态框
function openEditModal(post) {
  isEdit.value = true
  form.id = post.id
  form.code = post.code
  form.name = post.name
  form.alias = post.alias || ''
  form.postLevel = post.postLevel || ''
  form.sort = post.sort
  form.status = post.status ?? true
  form.remark = post.remark || ''
  showModal.value = true
}

// 关闭模态框
function closeModal() {
  showModal.value = false
}

// 保存岗位
async function savePost() {
  if (!form.code.trim()) {
    ElMessage.warning('请输入岗位编码')
    return
  }
  if (!form.name.trim()) {
    ElMessage.warning('请输入岗位名称')
    return
  }

  const payload = {
    id: form.id,
    name: form.name,
    code: form.code,
    alias: form.alias,
    postLevel: form.postLevel,
    sort: form.sort,
    status: form.status,
    remark: form.remark
  }

  try {
    if (isEdit.value) {
      await updatePost(form.id, payload)
      ElMessage.success('修改成功')
    } else {
      await createPost(payload)
      ElMessage.success('新增成功')
    }
    await fetchPosts(page.value)
    closeModal()
  } catch (error) {
    ElMessage.error(error.message || '操作失败')
  }
}

// 删除岗位
function handleDelete(post) {
  pendingDelete.value = post
  showDeleteModal.value = true
}

// 确认删除
async function confirmDelete() {
  if (pendingDelete.value) {
    try {
      await deletePost(pendingDelete.value.id)
      ElMessage.success('删除成功')
      await fetchPosts(page.value)
    } catch (error) {
      ElMessage.error(error.message || '删除失败')
    }
  }
  closeDeleteModal()
}

// 关闭删除确认弹窗
function closeDeleteModal() {
  showDeleteModal.value = false
  pendingDelete.value = null
}

function handlePageChange(p) {
  page.value = p
  fetchPosts(p)
}

function handlePageSizeChange(s) {
  size.value = s
  page.value = 1
  fetchPosts(1)
}

onMounted(() => {
  fetchPosts()
})
</script>

<style scoped>
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
